














import {Vue, Component} from 'vue-property-decorator';
import { mapGetters } from "vuex";
import firebase from "firebase";
import "../registerServiceWorker";
import Routes from '@/router/index';
import router from '@/router/index';
import HomeViewModule from '@/store/view/HomeViewModule';
import AddDocumentDialog from '@/components/AddDocumentDialog.vue';

@Component({
    components: {
        AddDocumentDialog,
    }
})
export default class ActionNavbar extends Vue {
    public addDocumentDialog() {
        HomeViewModule.loadPromptAddDocumentDialog(true);
    }

    public navigateBack() {
        router.go(-1);
    }

    public get user() {
            return this.$store.getters.user;
    }

    public get topics() {
        return HomeViewModule.documentSearchTopics;
    }

};
